import {
  WiCloud,
  WiCloudy,
  WiDayCloudy,
  WiDaySunny,
  WiFog,
  WiRain,
  WiShowers,
  WiSnow,
  WiThunderstorm,
} from "react-icons/wi";

const WEATHER_ICON_MAP = {
  weather_clear_day: WiDaySunny,
  weather_clear_night: WiDaySunny,
  weather_cloud: WiCloud,
  weather_cloudy: WiCloudy,
  weather_cloud_sun: WiDayCloudy,
  weather_drizzle: WiShowers,
  weather_fog: WiFog,
  weather_hail: WiRain,
  weather_light_rain: WiShowers,
  weather_partly_cloudy: WiDayCloudy,
  weather_rain: WiRain,
  weather_snow: WiSnow,
  weather_storm: WiThunderstorm,
  weather_thunderstorm: WiThunderstorm,
  weather_wind: WiCloudy,
};

const getWeatherIconByKey = (iconKey) =>
  WEATHER_ICON_MAP[iconKey] || WEATHER_ICON_MAP.weather_cloud_sun;

export default getWeatherIconByKey;
